import React from 'react'
import dodatafound from '../../../assets/images/dodatafound.svg'
import './noParticipantsFound.css'
const NoParticipantsFound = () => {
  return (
    <div>
        <img src={dodatafound} alt="No Participants Found" />
        <div className="no-data-found-content">
        <span className="no-data-found-title">No Data Found</span>
        <span className="no-data-found-description">There is no data to show you right now</span>

        </div>
       
    </div>
  )
}

export default NoParticipantsFound